import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "AdManagerAdvertisingZoneGroupEditDialog",
  props: {
    dialog: { type: Boolean, default: false },
    editedItem: { type: Object, default: null },
    currentPrincipal: { type: String, default: "" },
    zones: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerDialog: false,
      localItem: this.blank(),
      initialItem: {},
      isLoadingGroups: false,
      valid: false,
      saving: false,
      mainPeacock: "#00636C",
      req: v => !!v || "Pflichtfeld"
    };
  },
  watch: {
    dialog(val) {
      this.innerDialog = val;
      if (val) {
        this.fillData();
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    principals() {
      return this.$store.state.principals;
    }
  },
  methods: {
    blank() {
      return {
        _id: "",
        principal_id: this.currentPrincipal,
        name: "",
        zones: []
      };
    },
    fillData() {
      const base = this.editedItem
        ? JSON.parse(JSON.stringify(this.editedItem))
        : this.blank();
      base.principal_id = this.currentPrincipal;
      this.localItem = base;
      this.initialItem = window.structuredClone(this.localItem);
      this.$nextTick(() => this.$refs.form?.resetValidation());
    },
    async onSave() {
      const ok = await this.$refs.form.validate();
      if (!ok) return;

      this.saving = true;
      const headers = getTokenHeader();
      const payload = {
        ...this.localItem,
        principal_id: this.currentPrincipal
      };
      if (!payload._id) delete payload._id;

      try {
        if (this.localItem._id) {
          await axios.put(
            env.ad_manager_api_client_url + "ad/groups/" + this.localItem._id,
            payload,
            { headers }
          );
        } else {
          const r = await axios.post(
            env.ad_manager_api_client_url + "ad/groups",
            payload,
            { headers }
          );
          this.localItem._id = r.data?._id || this.localItem._id;
        }
        this.$emit("afterSave");
        this.onCancel();
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", "Speichern fehlgeschlagen");
      } finally {
        this.saving = false;
      }
    },
    onCancel() {
      this.$emit("close");
      this.$emit("update:dialog", false);
    }
  }
};
